module.exports = __webpack_public_path__ + "img/chat.2eaae9b7.svg";